// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"676a86496638f9332c68","655":"7e9610e9d26f4c0320d2"}[chunkId] + ".js";
};